module.exports = __webpack_public_path__ + "img/extended.84237ac2.png";